import { GenericResponse } from "./generic-response.model";

export class CountryState {

}


export interface CountryPlaceholder {
    country_Name: string;
    country_Code: string;
    placeholder: string;
    country_Code2:string
}
export interface Country {
  id: number;
  name: string;
  code: string;
  code2: string;
  code2Lower: string;
  dialCode: number;
  placeholder: string;
}


export interface CountryListResponse extends GenericResponse {
  countries: Country[];
}
